import axios from "axios";
import { toast } from "react-toastify";

const customAxios = axios.create({});

let _onExpired = null;
export const setExpiredHandler = (fn) => { _onExpired = fn; };

customAxios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 402) {
      let message = error.response?.data?.message || error.message || "Your membership has expired.";
      toast.error(message);
      if (_onExpired) _onExpired();
    }
    return Promise.reject(error);
  }
);

export const setAuthToken = (token) => {
  if (token) {
    customAxios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
  } else {
    delete customAxios.defaults.headers.common["Authorization"];
  }
};
export default customAxios;
